<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-lg-12 text-end">
          <v-btn color="success darken-2" text small @click="openNewBranchDialog()"
          ><v-icon small left>mdi-plus</v-icon> Şube Ekle</v-btn
          >
        </div>
      </div>
      <div class="row">
        <ResultTableView
            :perPage="perPage"
            :currentPage="currentPage"
        ></ResultTableView>
      </div>
      <!-- end row -->
    </div>

    <EditBranchDialog
        :branchProp="branchProp"
        :processType="'new'"
        :showDialog="newBranchDialog"
        @dialogChange="(data) => (newBranchDialog = data)"
    >

    </EditBranchDialog>
  </div>
</template>

<script>

import {mapActions, mapState} from "vuex";
import ResultTableView from "@/components/management/branch-management/results/ResultsTableView.vue";
import EditBranchDialog from "@/components/management/branch-management/dialogs/EditBranchDialog.vue";

export default {
  name: "Results.vue",
  components: {ResultTableView, EditBranchDialog},
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      branchProp: null,
      newBranchDialog: false,
    }
  },
  methods: {
    ...mapActions('company', ["fetchCompanyBranchList","deleteCompanyBranch"]),
    openNewBranchDialog() {
      this.newBranchDialog = true;
    }
  },
  computed: {
    ...mapState('company', ['companyBranchList','companyBranchListLoading','companyBranchListHeaders'])
  },
  mounted() {
    this.fetchCompanyBranchList({
      params:{
      },
      body:{

      },
    })
  }
}
</script>


<style scoped>

</style>